<div class="dm-tree">
    <div class="dm-tree-items">
        <ng-container [ngTemplateOutlet]="nodesTpl" [ngTemplateOutletContext]="{ $implicit: items(), lvl: 0 }" />
    </div>
</div>

<ng-template let-nodes let-lvl="lvl" let-disabled="disabled" let-parent="parent" #nodesTpl>
    @for (node of nodes; track node.id) {
        @let hcf = hasChildrenFn();
        @let expandable = !!node.children || (async() && (!hcf || hcf(node)));
        <div class="dm-tree-node"
            [ngClass]="'dm-tree-level-' + lvl"
            [class.dm-tree-expandable]="expandable"
            [class.dm-tree-expanded]="expanded()[node.id]"
            [class.dm-tree-loading]="loading[node.id]"
            [class.dm-tree-nochildren]="node.children != null && node.children.length == 0">
            @let wcFn = wrapperClassesFn();
            <div class="dm-tree-item-wrapper" [ngClass]="wcFn ? wcFn(node) : undefined">
                <div class="dm-tree-folder" (click)="loading[node.id] || !expandable ? undefined : toggleExpanded(node)">
                    @if (loading[node.id]) {
                        <span class="dm-tree-loader"></span>
                    }
                    @else if (expandable) {
                        <span class="dm-tree-fold"
                            [title]="expanded()[node.id] ? '' : foldTooltip() || ''"
                            [class.dm-tree-fold-expanded]="expanded()[node.id]"
                            [class.dm-tree-fold-hidden]="levelLimit() <= lvl">
                        </span>
                    }
                </div>
                <div class="dm-tree-item" (click)="onItemClick($event, node)" (contextmenu)="itemContextMenu.emit({ e: $event, item: node })">
                    @if (itemTpl(); as nodeTpl) {
                        <ng-container
                            [ngTemplateOutlet]="nodeTpl"
                            [ngTemplateOutletContext]="{ $implicit: node, lvl, parent, disabled: node._disabled || disabled || disabledNodes()[node.id] }" />
                    }
                    @else {
                        #{{ node.id }}
                    }
                </div>
            </div>
            @if (expanded()[node.id]) {
                <div class="dm-tree-children" animate.enter="vza-show-h" animate.leave="vza-hide-h">
                    <div class="dm-tree-line" (click)="loading[node.id] ? undefined : toggleExpanded(node)">
                        <span></span>
                    </div>
                    <div class="dm-tree-items">
                        @if (node.children?.length && levelLimit() > lvl) {
                            <ng-container
                                [ngTemplateOutlet]="nodesTpl"
                                [ngTemplateOutletContext]="{ $implicit: node.children, lvl: lvl + 1, parent: node, disabled: node._disabled || disabled || disabledNodes()[node.id] }" />
                        }
                        @else {
                            <span class="dm-tree-noitems"></span>
                        }
                        @if (childrenFooterTpl(); as footer) {
                            <ng-container [ngTemplateOutlet]="footer" [ngTemplateOutletContext]="{ $implicit: node, lvl }" />
                        }
                    </div>
                </div>
            }
        </div>
    }
</ng-template>
